import utilArr from '@/util/arr'
import utilCommon from '@/util/common'
import utilDate from '@/util/date'
import utilObj from '@/util/obj'

export default {
  //checkUserType: state => (type) => {
  //  if (!state.auth.state) return false
  //  if (state.auth.user == null) return false
  //  return state.auth.user.type == type
  //},

  isAuthUser: state => () => {
    return Boolean(state.user)
  },

  isAuthUserEmailVerified: state => () => {
    if (!state.user) return false
    return state.user.emailVerified
  },

  isLoading: state => () => {
    return state.common.loadingItems.length > 0
  },

  isAdminUser: state => () => {
    return Boolean(state.adminUser)
  },

  adminRole: state => () => {
    if (state.adminUser == null) return
    if (utilObj.checkObjHasProp(state.adminUser, 'attributes') === false) return
    if (utilObj.checkObjHasProp(state.adminUser.attributes, 'role') === false) return
    return state.adminUser.attributes.role
  },

  checkAdminRole: state => (role) => {
    if (state.adminUser == null) return false
    if (utilObj.checkObjHasProp(state.adminUser, 'attributes') === false) return false
    if (utilObj.checkObjHasProp(state.adminUser.attributes, 'role') === false) return false
    return state.adminUser.attributes.role === role
  },

  hasAdminRole: state => () => {
    if (state.adminUser == null) return false
    if (utilObj.checkObjHasProp(state.adminUser, 'attributes') === false) return false
    if (utilObj.checkObjHasProp(state.adminUser.attributes, 'role') === false) return false
    return state.adminUser.attributes.role === 'admin'
  },

  hasEditorRole: state => () => {
    if (state.adminUser == null) return false
    if (utilObj.checkObjHasProp(state.adminUser, 'attributes') === false) return false
    if (utilObj.checkObjHasProp(state.adminUser.attributes, 'role') === false) return false
    const editorRoles = ['admin', 'editor']
    return editorRoles.includes(state.adminUser.attributes.role)
  },

  adminUserAcceptServiceIds: state => () => {
    if (state.adminUser == null) return []
    if ('attributes' in state.adminUser === false) return []
    if ('acceptServiceIds' in state.adminUser.attributes === false) return []
    if (! state.adminUser.attributes.acceptServiceIds) return []
    return state.adminUser.attributes.acceptServiceIds.split(',')
  },

  checkServiceIdAccepted: state => (serviceId) => {
    if (state.adminUser == null) return false
    if ('attributes' in state.adminUser === false) return false
    if ('acceptServiceIds' in state.adminUser.attributes === false) return false
    if (! state.adminUser.attributes.acceptServiceIds) return false
    const acceptServiceIds = state.adminUser.attributes.acceptServiceIds.split(',')
    return acceptServiceIds.includes(serviceId)
  },

  // For User Post
  postListStored: state => (serviceId) => {
    if (state.postListServiceId != serviceId) return false
    return state.postList.length > 0
  },

  postsPagerQueryCurrent: state => (forRequest=false) => {
    let params = {
      sort: state.postsPager.sort,
      order: state.postsPager.order,
    }

    if (utilObj.checkObjHasProp(state.postsPager, 'category', true)) {
      params.category = state.postsPager.category
    }

    if (state.postsPager.lastIndex != null) {
      params.index = state.postsPager.lastIndex
    }
    return params
  },

  postsPagerIndexCount: state => () => {
    return state.postsPager.keys.length
  },

  // For Adimin Post
  adminPostListStored: state => (serviceId) => {
    if (state.adminPostListServiceId != serviceId) return false
    return state.adminPostList.length > 0
  },

  adminPostsPagerQueryCurrent: state => (forRequest=false) => {
    let params = {
      sort: state.adminPostsPager.sort,
      order: state.adminPostsPager.order,
    }

    const reqKeys = ['attribute', 'compare', 'value']
    if (utilObj.checkObjItemsNotEmpty(state.adminPostsPager.filters, reqKeys, true)) {
      if (forRequest) {
        params.filters = JSON.stringify(state.adminPostsPager.filters)
      } else {
        params.filters = state.adminPostsPager.filters
      }
    }

    if (utilObj.checkObjHasProp(state.adminPostsPager, 'category', true)) {
      params.category = state.adminPostsPager.category
    }

    if (state.adminPostsPager.lastIndex != null) {
      params.index = state.adminPostsPager.lastIndex
    }
    return params
  },

  adminPostsPagerIndexCount: state => () => {
    return state.adminPostsPager.keys.length
  },

  learningElapsedTime: state => () => {
    if (!state.learning.startTime) return 0
    return utilDate.calcElapsedTime(state.learning.startTime)
  },

  learningElapsedTimeCurrent: state => () => {
    if (!state.learning.current.startTime) return 0
    return utilDate.calcElapsedTime(state.learning.current.startTime)
  },

  learningRestTime: state => () => {
    return utilDate.calcRestTime(state.learning.endTime)
  },

  learningRestTimeCurrent: state => () => {
    return utilDate.calcRestTime(state.learning.current.endTime)
  },

  isPreparedDrill: state => () => {
    if (Boolean(state.user) === false) return false
    if (! state.learning.drillId) return false
    return !state.learning.startTime
  },

  isExecutingDrill: state => () => {
    if (Boolean(state.user) === false) return false
    if (! state.learning.drillId) return false
    return state.learning.startTime > 0
  },

  isExecutingAnswer: state => () => {
    if (Boolean(state.user) === false) return false
    if (! state.learning.current.userAnswerId) return false
    return state.learning.current.startTime > 0
  },

  currentUserAnswer: state => () => {
    if (Boolean(state.user) === false) return
    if (! state.learning.current.userAnswerId) return
    return state.learning.userAnswers.find((item) => {
      return item.userAnswerId === state.learning.current.userAnswerId
    })
  },

  nextUserAnswer: state => () => {
    if (! state.learning.current.userAnswerId) return
    if (! state.learning.userAnswers) return

    const current = state.learning.userAnswers.find((item) => {
      return item.userAnswerId === state.learning.current.userAnswerId
    })
    if (!current) return

    const answersCount = state.learning.userAnswers.length
    const cindex =  state.learning.userAnswers.findIndex((item) => {
      return item.userAnswerId === current.userAnswerId
    })
    if (cindex >= answersCount - 1) return

    const nindex = cindex + 1
    return state.learning.userAnswers[nindex]
  },

  adminShortenUrlsPagerIndexCount: state => () => {
    return state.adminShortenUrlsPager.keys.length
  },

  //userInfo: state => (key) => {
  //  const acceptKey = [
  //    'uid', 'name', 'email', 'photoURL'
  //  ]
  //  if (!state.auth.state) return
  //  if (state.auth.user == null) return
  //  if (!utilArr.inArray(key, acceptKey)) return
  //  if (utilObj.isEmpty(state.auth.user[key])) return
  //  return state.auth.user[key]
  //},

  //isEmailVerified: state => () => {
  //  if (!state.auth.state) return false
  //  if (state.auth.user == null) return false
  //  return state.auth.user.emailVerified === true
  //},
}
